// Mock data for the trademark service website

export const services = [
  {
    id: 1,
    title: 'Trademark Registration',
    description: 'Secure your brand identity with full legal protection and ownership rights',
    icon: 'Shield',
    link: '/trademark-registration',
    features: [
      'Complete USPTO filing',
      'Expert review',
      'Status tracking',
      'Legal compliance'
    ]
  },
  {
    id: 2,
    title: 'Copyright Registration',
    description: 'Protect your creative work from copying with complete legal ownership rights',
    icon: 'FileText',
    link: '/copyright-registration',
    features: [
      'Copyright filing',
      'Legal protection',
      'Quick processing',
      'Full documentation'
    ]
  },
  {
    id: 3,
    title: 'Trademark Search',
    description: 'Check trademark availability instantly with accurate and reliable search results',
    icon: 'Search',
    link: '/trademark-search',
    features: [
      'Comprehensive search',
      'Conflict analysis',
      'Detailed reports',
      'Risk assessment'
    ]
  },
  {
    id: 4,
    title: 'Amazon Brand Registry',
    description: 'Protect your Amazon listings from infringement with strong brand control tools',
    icon: 'ShoppingBag',
    link: '/amazon-brand-registry',
    features: [
      'Brand protection',
      'Enhanced content',
      'Increased visibility',
      'Sales growth'
    ]
  },
  {
    id: 5,
    title: 'Company Formation',
    description: 'Start your business with proper legal structure and complete registration support',
    icon: 'Building2',
    link: '/company-formation',
    features: [
      'LLC/Corp formation',
      'EIN registration',
      'State compliance',
      'Fast processing'
    ]
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: 'Basic',
    price: 45,
    originalPrice: 55,
    recommended: false,
    description: 'Essential trademark protection for startups and small businesses.',
    features: [
      'Case Review',
      'Case Filing',
      'Basic Search',
      'State E-Filing',
      'Trademark Secured'
    ]
  },
  {
    id: 2,
    name: 'Deluxe',
    price: 145,
    originalPrice: 155,
    recommended: true,
    description: 'Enhanced protection with dedicated case management.',
    features: [
      'Case Review',
      'Case Filing',
      'Basic Search',
      'State E-Filing',
      'Trademark Secured',
      'Direct Hit Search',
      'Dedicated Case Manager'
    ]
  },
  {
    id: 3,
    name: 'Economy',
    price: 595,
    originalPrice: 755,
    recommended: false,
    description: 'Comprehensive protection with expert review and monitoring.',
    features: [
      'Case Review (by a TM Expert)',
      'Basic Free Trademark Search',
      'Trademark Monitoring Services (3 Months)',
      'Trademark Secured',
      'Refusal Risk Meter',
      'Case filing service with complete paperwork'
    ]
  },
  {
    id: 4,
    name: 'Elite',
    price: 895,
    originalPrice: 1055,
    recommended: false,
    description: 'Premium service with U.S. Registered IP Attorney and full protection.',
    features: [
      'Case Review & Filing (U.S Registered IP Attorney)',
      'Assigned Case Filing Officer',
      'Private Registration',
      'Federal Search & Clearance Report (All States)',
      'Federal E-Filing (USPTO)',
      'Cease & Desist Letter',
      'Same Day Filing',
      'Trademark Monitoring (1 Year)',
      'Trademark Secured',
      'Direct Hit Search',
      'Dedicated Case Manager',
      '24/7 Secure Online Access',
      '100% Approval Guarantee'
    ]
  }
];

export const copyrightPricing = [
  {
    id: 1,
    name: 'Gold',
    price: 99,
    recommended: false,
    description: 'Essential copyright protection for your creative works.',
    features: [
      'Professional Preparation of your federal copyright application',
      'Review by copyright team for accuracy and completeness',
      'Federal E-Filing with the USPTO',
      'Electronic filing with no paper files',
      'Certificate of Registration mailed directly from U.S. Copyright Office',
      '+ USPTO Filing Fee'
    ]
  },
  {
    id: 2,
    name: 'Diamond',
    price: 149,
    recommended: true,
    description: 'Premium copyright protection with expedited service.',
    features: [
      'Cease & Desist Letter (customer-specific form)',
      'Transfer/Assignment custom template',
      'Pre-filled templates you can customize',
      '24 Hours Expedited Process',
      'All features from Gold package',
      '+ USPTO Filing Fee'
    ]
  }
];

export const amazonBrandPricing = [
  {
    id: 1,
    name: 'Standard',
    price: 99,
    recommended: false,
    description: 'Essential Amazon brand protection.',
    features: [
      'Amazon Brand Case Review',
      'Amazon Brand Case Filing',
      '100% Satisfaction Guarantee',
      '+ USPTO filing fee'
    ]
  },
  {
    id: 2,
    name: 'Diamond',
    price: 149,
    recommended: true,
    description: 'Enhanced protection with risk assessment.',
    features: [
      'Amazon Brand Case Review',
      'Amazon Brand Case Preparation',
      'Amazon Brand Case Filing',
      '100% Satisfaction Guarantee',
      'Refusal Risk Meter',
      '+ USPTO filing fee'
    ]
  },
  {
    id: 3,
    name: 'Premium',
    price: 199,
    recommended: false,
    description: 'Complete solution with dedicated support.',
    features: [
      'Amazon Brand Case Review',
      'Amazon Brand Case Preparation',
      'Amazon Brand Case Filing',
      '100% Satisfaction Guarantee',
      'Refusal Risk Meter',
      'Amazon Brand Case Monitoring',
      'Complete Documentation',
      'Digital File',
      'Dedicated Case Manager',
      '+ USPTO filing fee'
    ]
  }
];

export const trademarkSearchPricing = [
  {
    id: 1,
    name: 'Federal & State Search',
    price: 149,
    recommended: false,
    description: 'Comprehensive search across federal and state databases.',
    features: [
      'Federal trademark search (USPTO)',
      'State search across all 50 states',
      'Detailed online report',
      'Identifies similar names, logos, and slogans'
    ]
  },
  {
    id: 2,
    name: 'Federal, State & Common Law',
    price: 299,
    recommended: true,
    description: 'Extensive search including common law and corporate names.',
    features: [
      'Federal & State Search included',
      'Corporate name search (all 50 states)',
      'Corporate directories search',
      'Common law proprietary internet searches',
      'Domain name search',
      'Comprehensive conflict analysis'
    ]
  },
  {
    id: 3,
    name: 'Global Search',
    price: 499,
    recommended: false,
    description: 'International trademark search across multiple jurisdictions.',
    features: [
      'All Federal, State & Common Law features',
      'European Community search',
      'WIPO (World Intellectual Property Organization)',
      'Multi-national jurisdiction coverage',
      'Global domain name search'
    ]
  }
];

// Unique testimonials for each service
export const trademarkTestimonials = [
  {
    id: 1,
    name: 'Olivia Carter',
    role: 'Startup Founder',
    content: 'I needed fast trademark filing for my startup, and Assess Trademark delivered exactly what they promised. Quick response, smooth process, and great support throughout.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ethan Reynolds',
    role: 'E-commerce Entrepreneur',
    content: 'Their service saved me a lot of confusion. I didn\'t understand trademarks before, but Assess Trademark explained everything in simple steps and handled all the filing professionally.',
    rating: 5
  },
  {
    id: 3,
    name: 'Sophia Mitchell',
    role: 'Brand Manager',
    content: 'Very professional and reliable service. My trademark application was processed without any issues, and I received timely updates at every stage.',
    rating: 5
  },
  {
    id: 4,
    name: 'Daniel Brooks',
    role: 'Freelance Designer',
    content: 'Excellent experience from start to finish. The team was responsive and made sure my brand was properly protected without any delays.',
    rating: 5
  },
  {
    id: 5,
    name: 'Ava Thompson',
    role: 'Online Store Owner',
    content: 'I really appreciate how easy they made the process. Assess Trademark handled everything efficiently, and I finally have legal protection for my brand.',
    rating: 5
  },
  {
    id: 6,
    name: 'Liam Foster',
    role: 'Small Business Founder',
    content: 'The support team was always available and very helpful. They guided me step by step and ensured my trademark filing was completed correctly.',
    rating: 5
  }
];

export const copyrightTestimonials = [
  {
    id: 1,
    name: 'Michael Chen',
    role: 'Author & Writer',
    content: 'Protecting my literary work was essential. Assess Trademark made copyright registration simple and quick. Highly recommended for authors!',
    rating: 5
  },
  {
    id: 2,
    name: 'Emma Rodriguez',
    role: 'Professional Photographer',
    content: 'My photography is my livelihood. Assess Trademark helped me secure copyright protection for my entire portfolio efficiently.',
    rating: 5
  },
  {
    id: 3,
    name: 'Alex Thompson',
    role: 'Software Developer',
    content: 'Needed to protect my software code. The team handled everything professionally and explained the process clearly.',
    rating: 5
  },
  {
    id: 4,
    name: 'Jessica Park',
    role: 'Music Producer',
    content: 'Excellent service for protecting my musical compositions. Fast, affordable, and the team really understood my needs.',
    rating: 5
  },
  {
    id: 5,
    name: 'Daniel Foster',
    role: 'Film Director',
    content: 'Copyright protection for my film projects was crucial. Assess Trademark delivered exceptional service with attention to detail.',
    rating: 5
  }
];

export const companyTestimonials = [
  {
    id: 1,
    name: 'Robert Kim',
    role: 'New LLC Owner',
    content: 'Forming my LLC was stress-free with Assess Trademark. They handled all the paperwork and got me up and running in a week!',
    rating: 5
  },
  {
    id: 2,
    name: 'Maria Garcia',
    role: 'Restaurant Owner',
    content: 'Starting my restaurant business required proper formation. Assess Trademark made it simple and affordable. Great experience!',
    rating: 5
  },
  {
    id: 3,
    name: 'Tom Anderson',
    role: 'Consultant',
    content: 'Professional service for my S-Corp formation. They explained everything clearly and ensured full compliance.',
    rating: 5
  },
  {
    id: 4,
    name: 'Nina Patel',
    role: 'Tech Startup Founder',
    content: 'Forming our C-Corp was seamless. Assess Trademark provided expert guidance and fast processing. Highly recommend!',
    rating: 5
  },
  {
    id: 5,
    name: 'Carlos Martinez',
    role: 'E-commerce Store Owner',
    content: 'Quick and efficient LLC formation for my online store. Assess Trademark made the process incredibly easy!',
    rating: 5
  }
];

export const amazonTestimonials = [
  {
    id: 1,
    name: 'Jason M. Johnson',
    role: 'Amazon FBA Seller',
    content: 'Assess Trademark helped me navigate Amazon Brand Registry. My products are now protected and my sales have increased!',
    rating: 5
  },
  {
    id: 2,
    name: 'Kelly Brooks',
    role: 'Private Label Seller',
    content: 'Getting enrolled in Brand Registry opened up so many tools. Assess Trademark made the process quick and painless.',
    rating: 5
  },
  {
    id: 3,
    name: 'Marcus Williams',
    role: 'Amazon Entrepreneur',
    content: 'Brand protection on Amazon is crucial. The team handled everything and I now have full access to A+ Content!',
    rating: 5
  },
  {
    id: 4,
    name: 'Rachel Green',
    role: 'Online Retailer',
    content: 'Professional service for Amazon Brand Registry. My brand is now protected from counterfeits. Thank you!',
    rating: 5
  },
  {
    id: 5,
    name: 'Steven Cooper',
    role: 'Brand Owner',
    content: 'Amazon Brand Registry enrollment was seamless with Assess Trademark. My brand has better visibility and control now.',
    rating: 5
  }
];

export const searchTestimonials = [
  {
    id: 1,
    name: 'Daniel Martinez',
    role: 'Startup Founder',
    content: 'The comprehensive trademark search saved me from costly mistakes. Found potential conflicts I would have missed!',
    rating: 5
  },
  {
    id: 2,
    name: 'Sophie Turner',
    role: 'Brand Manager',
    content: 'Thorough search report with expert analysis. Assess Trademark helped me make an informed decision about my trademark.',
    rating: 5
  },
  {
    id: 3,
    name: 'Chris Lee',
    role: 'Product Developer',
    content: 'The search identified similar marks I wasn\'t aware of. Professional service that gave me confidence to proceed.',
    rating: 5
  },
  {
    id: 4,
    name: 'Amanda White',
    role: 'Business Owner',
    content: 'Fast turnaround on my trademark search. Detailed report helped me refine my brand strategy before filing.',
    rating: 5
  },
  {
    id: 5,
    name: 'Kevin Johnson',
    role: 'Entrepreneur',
    content: 'Detailed trademark search gave me the confidence to move forward. Assess Trademark provided excellent service!',
    rating: 5
  }
];

export const testimonials = trademarkTestimonials;

export const faqs = [
  {
    id: 1,
    question: 'What is a trademark and why do I need one?',
    answer: 'A trademark is a legal protection for your brand name, logo, slogan, or identity that distinguishes your business from others. You need it to protect your brand from copycats, build trust with customers, and secure exclusive rights to use your business identity in your industry.'
  },
  {
    id: 2,
    question: 'How long does trademark registration take?',
    answer: 'Trademark registration usually takes between 6 to 12 months, depending on the application review process, any objections, and approval from the USPTO. Timelines can vary based on case complexity.'
  },
  {
    id: 3,
    question: 'What can be trademarked?',
    answer: 'You can trademark business names, logos, slogans, product names, and brand symbols that uniquely identify your goods or services in the market. The key requirement is that it must be distinctive and not already in use in the same category.'
  },
  {
    id: 4,
    question: 'What is the difference between ™ and ®?',
    answer: 'The ™ symbol is used for unregistered trademarks, meaning you are claiming rights but it is not officially registered yet. The ® symbol is used only after your trademark is officially registered and approved by the USPTO, giving full legal protection.'
  },
  {
    id: 5,
    question: 'How much does trademark filing cost?',
    answer: 'Trademark filing costs typically start at $45 with basic service packages, plus the official USPTO government filing fee. The total cost depends on the package you choose and the level of protection and services included.'
  }
];

export const trademarkSearchResults = [
  {
    id: 1,
    name: 'TechFlow',
    status: 'Available',
    risk: 'Low',
    category: 'Technology',
    description: 'No conflicts found in USPTO database'
  },
  {
    id: 2,
    name: 'TechFlow Pro',
    status: 'Potential Conflict',
    risk: 'Medium',
    category: 'Technology',
    description: 'Similar trademark found - "TechFlo" registered in 2020'
  },
  {
    id: 3,
    name: 'Apple',
    status: 'Not Available',
    risk: 'High',
    category: 'Technology',
    description: 'Already registered - Apple Inc. trademark since 1977'
  },
  {
    id: 4,
    name: 'BrightPath',
    status: 'Available',
    risk: 'Low',
    category: 'Consulting',
    description: 'No conflicts found in USPTO database'
  },
  {
    id: 5,
    name: 'EcoGreen',
    status: 'Available',
    risk: 'Medium',
    category: 'Environment',
    description: 'Multiple similar names exist - recommend unique variation'
  }
];

export const howItWorks = [
  {
    step: 1,
    title: 'Submit Your Details',
    description: 'Fill a short form with your brand name and business details.'
  },
  {
    step: 2,
    title: 'We Manage the Filing',
    description: 'Our professionals prepare and submit your trademark application to the USPTO.'
  },
  {
    step: 3,
    title: 'Receive Official Protection',
    description: 'Once approved, your trademark becomes officially registered — securing your brand.'
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Expert Support',
    description: 'Our trademark specialists handle applications carefully to reduce delays and errors.',
    icon: 'Award'
  },
  {
    id: 2,
    title: 'Simple & Fast Process',
    description: 'We make trademark filing smooth, quick, and stress-free online.',
    icon: 'Zap'
  },
  {
    id: 3,
    title: 'Affordable Plans',
    description: 'We provide clear pricing with full transparency—no hidden charges at all.',
    icon: 'DollarSign'
  }
];

export const partnerLogos = [
  { id: 1, name: 'Partner 1' },
  { id: 2, name: 'Partner 2' },
  { id: 3, name: 'Partner 3' },
  { id: 4, name: 'Partner 4' },
  { id: 5, name: 'Partner 5' },
  { id: 6, name: 'Partner 6' },
  { id: 7, name: 'Partner 7' }
];
